import React, { useState, useEffect } from 'react';
import './PersonalDetails.css';
import IdPassport from '../../Components/IdPassport/IdPassort';
import { withRouter } from 'react-router-dom';
import { VettingLeftArrow } from '../Common';

const PersonalDetails = (props) => {
  const [validIdPassportDetails, setValidIdPassportDetails] = useState();

  const enableNext = (key, value) => {
    if (key === 'idPassport') {
      setValidIdPassportDetails(value);
    }
  }

  useEffect(() => {
    if (validIdPassportDetails) {
      props.setValidPersonalDetails(true);
    } else {
      props.setValidPersonalDetails(false);
    }
  }, [validIdPassportDetails]);

  return (
    <div className="personal-details-wrapper">
      <div className="id-section-wrapper">
        <div className="id-section-heading">
          Let's get started
        </div>
        <IdPassport validIdPassportDetails={(value) => { enableNext('idPassport', value) }} />
      </div>
    </div>
  )
}

export default withRouter(PersonalDetails);